// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3BKqb","label":"Category_label__1MwVi","content":"Category_content__1hOiF","header":"Category_header__1He0E","location":"Category_location__xfgSP"};